import * as tslib_1 from "tslib";
import common from "../../../../../../common/pc";
import { ReverseRelevanceControl } from "../../../../../../form/src/common/controls/reverse-relevance-control";
import { Component } from "vue-property-decorator";
import ReverseRelevanceLink from "./reverse-relevance-link.vue";
import ReverseRelevanceList from "./reverse-relevance-list.vue";
let ReverseRelevance = class ReverseRelevance extends ReverseRelevanceControl {
    get tips() {
        return this.control.options.tips;
    }
};
ReverseRelevance = tslib_1.__decorate([
    Component({
        name: "reverse-relevance",
        components: {
            ReverseRelevanceList,
            ReverseRelevanceLink,
            H3Panel: common.components.Panel,
        },
    })
], ReverseRelevance);
export default ReverseRelevance;
